(function(){
  function qs(s,root){return (root||document).querySelector(s)}
  function qsa(s,root){return Array.prototype.slice.call((root||document).querySelectorAll(s))}

  function ready(){
    var h=qs('.site-header');
    if(h){
      var f=function(){
        h.classList.toggle('scrolled',window.scrollY>12)
      };
      f();
      window.addEventListener('scroll',f,{passive:true});
    }

    var t=qs('.mobile-toggle'),
        m=qs('.mobile-menu'),
        c=qs('.mobile-close');

    if(t&&m)t.addEventListener('click',function(){
      m.classList.add('open')
    });

    if(c&&m)c.addEventListener('click',function(){
      m.classList.remove('open')
    });

    setupLightbox();
  }

  function setupLightbox(){
    var lb=document.createElement('div');
    lb.className='lightbox';
    lb.innerHTML='<button class="lightbox-close" aria-label="Close">&times;</button><img alt="">';
    document.body.appendChild(lb);

    var img=qs('img',lb),
        close=qs('.lightbox-close',lb);

    function closeLb(){
      lb.classList.remove('open');
      img.removeAttribute('src');
    }

    close.addEventListener('click',closeLb);

    lb.addEventListener('click',function(e){
      if(e.target===lb)closeLb();
    });

    document.addEventListener('keydown',function(e){
      if(e.key==='Escape')closeLb();
    });

    qsa('[data-lightbox-src]').forEach(function(btn){
      btn.addEventListener('click',function(e){
        e.preventDefault();
        img.src=btn.getAttribute('data-lightbox-src');
        img.alt=btn.getAttribute('data-lightbox-alt')||'';
        lb.classList.add('open');
      });
    });
  }

  document.addEventListener('DOMContentLoaded',ready);
})();
